<template>
  <div class="container onboard-container">
    <div class="columns" v-if="!show_thank_you">
      <div class="column is-two-thirds equal-height">
        <div class="form-box">
          <h1 class="Create-your-account color-blue-dark">Create your account</h1>
          <h6 class="Business-details">Business&nbsp;details</h6>
          <p class="form-para">Your business name and industry will be displayed on your business profile page.</p>
          <form :name="makeFormName">
            <div class="field is-grouped is-grouped-multiline dropdown-section">
              <div @mouseleave.self="hideBusinessAutoComplete" :class="['control', { 'is-loading' : isFetchingBusinesses }, { 'has-icons-right' : isBusinessSelected }]">
                <input style="display:none;" type="text"/>
                <!--<span class="selected-business" v-if="form.business_name && business_is_selected">{{form.business_name}}</span>-->
                <input class="input" type="text" placeholder="Business name" autocomplete="off" v-model="form.business_name" @keyup="searchBusinesses"/>
                <span v-show="isBusinessSelected" class="icon is-small is-right" :class="[{ 'green' : isSelectedBusinessAvailable }, { 'red' : isSelectedBusinessNotAvailable }]"><i class="fas"
                                                                                                                                                                                     :class="[{ 'fa-check' : isSelectedBusinessAvailable }, { 'fa-times' : isSelectedBusinessNotAvailable }]"></i></span>
                <div class="no-height" v-show="(searchBusinessesFound || !business_is_selected) && form.business_name">
                  <div class="dropdown is-active">
                    <div class="dropdown-menu" role="menu">
                      <div class="dropdown-content is-paddingless">
                        <a v-for="(business, key) in businesses" @click.prevent="selectBusiness(business)" href="#" :ref="`${business.id}`" :key="`${key}`" class="dropdown-item has-text-left" v-text="business.name"></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="control">
                <custom-drop-down v-on:changed="selectIndustry($event)" place-holder="Select industry" dropdown-name="industry" :is-full-width="industry_dropdown_fullwidth" :items="industryList.industries"></custom-drop-down>
              </div>
            </div>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input v-model="form.phone_number" class="input" type="text" placeholder="Phone number (optional)"/>
                <p v-if="form.errors.has('phone_number')" class="help is-danger" v-text="form.errors.get('phone_number')"></p>
              </div>
              <div class="control">
                <custom-drop-down v-on:changed="selectCompanySize($event)" place-holder="Company size (optional)" dropdown-name="company_size" :is-full-width="industry_dropdown_fullwidth" :items="company_sizes"></custom-drop-down>
              </div>
            </div>


            <!-- CUSTOM SLIDER START JUST CALL THE CUSTOM COMPONENT I CREATED WITH AN ARRAY OF THE LABELS YOU WANT TO PRINT-->

            <!--            <div class="field">-->
            <!--              <custom-slider :labels="sliderLabels" default-value="1200"></custom-slider>-->
            <!--            </div>-->

            <!-- CUSTOM SLIDER END -->

            <h6 class="User-details">User&nbsp;details</h6>
            <p class="form-para">Create an account to access the Hellopeter business portal</p>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input v-model="form.first_name" class="input" type="text" placeholder="First name"/>
              </div>
              <div class="control">
                <input v-model="form.last_name" class="input" type="text" placeholder="Last name"/>
              </div>
            </div>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input v-model="form.email" class="input" type="text" placeholder="Email"/>
                <p v-if="invalidEmail" class="help is-danger">Email is invalid</p>
              </div>
              <div class="control">
                <vue-password v-model="form.password" placeholder="Password" classes="input force-height" :disableStrength="disableStrength"></vue-password>
                <p v-if="invalidPassword" class="help is-danger">Password needs to be at least 8 characters long</p>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label agree-label checkbox has-text-centered-desktop has-text-left-touch">
                  <input v-model="agreement_checked" type="checkbox" name="agreement" class="checkbox"/> &nbsp;
                  I agree to Hellopeter's <a href="https://www.hellopeter.com/legal/legal" target="_blank" class="hyperlinks">terms of service</a> and <a href="https://www.hellopeter.com/legal/privacy" target="_blank" class="hyperlinks">privacy
                  policy</a>
                </label>
              </div>
            </div>
            <p class="has-text-centered">
              <input type="submit" value="CREATE ACCOUNT" :disabled="!canSubmit || !agreement_checked || is_sending" :class="['button loginButton', { 'is-loading' : is_sending }]" @click.prevent="createOnboardRequest"/>
            </p>
            <p class="has-text-centered ask-sign-in">Already have an account?<br/><a href="/login" class="link">Sign in now</a></p>
          </form>
        </div>
      </div>
      <summary-section :cycle="frequency" :name="tier"></summary-section>
    </div>
    <!-- START ReCaptcha -->
    <div class="columns" v-if="!show_thank_you">
      <div class="column is-marginless">
        <div class="has-text-right-tablet">
          <vue-recaptcha
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            size="invisible"
            :sitekey="`${google_recaptcha_site_key}`">
          </vue-recaptcha>
        </div>
      </div>
    </div>
    <!-- END ReCaptcha -->
    <div class="hero thank-you-hero" v-if="show_thank_you">
      <div class="hero-body">
        <div class="has-text-centered">
          <div class="outter-ring">
            <div class="inner-ring">
              <img src="/static/img/packages/like_icon.svg" width="60"/>
            </div>
          </div>
          <h1 class="thank-you-header is-size-1-widescreen is-size-2-tablet is-size-2-desktop is-size-4-mobile has-text-weight-bold">Your business profile<br/>is in our hands.</h1>
          <p class="thank-you-msg" v-html="showThankYouMessage"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape,camelcase */
import axios from 'axios'
import ApiResource from '../../api/ApiResource'
import Errors from '../../api/Errors'
import business_search from '../../mixins/business_search'
import misc from '../../mixins/misc.js'
import {mapActions, mapState} from 'vuex'
import {FETCH_INDUSTRIES} from '@/store/action.types'
import VuePassword from 'vue-password'
import CustomDropDown from './../../components/DropDownGeneric'
import SummarySection from './../../components/SummaryTrial'
import CustomSlider from './../../components/InputSlider'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'NewOnboardTemplate',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Onboard'
  },
  props: {
    tier: {
      type: String,
      default: 'free'
    },
    frequency: {
      type: String,
      default: 'monthly'
    }
  },
  components: {
    CustomDropDown,
    VuePassword,
    SummarySection,
    CustomSlider,
    VueRecaptcha
  },
  mixins: [business_search, misc],
  watch: {
    form: {
      handler (formData) {
        if (formData.phone_number.length === 0) {
          this.form_errors.clear('Phone')
        }
      },
      deep: true
    }
  },
  data () {
    return {
      onboard_date: '',
      formsApiAxios: undefined,
      // sliderLabels: ['0', '5&#37;', '10&#37;', '15&#37;', '20&#37;'], // this is for saurabh, the one below is for billing
      sliderLabels: ['30', '100', '150', '250', '360', '1200', '1800', '3000', '6000', '12000', '18000', 'unlimited'],
      google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY,
      recaptchaToken: '',
      thankYouFreeEmail: '',
      businessAxios: undefined,
      searchCancelToken: undefined,
      billingAxios: undefined,
      searchResults: [],
      businesses: [],
      business_is_selected: false,
      selected_business_available: false,
      is_fetching_business: false,
      show_industry_dropdown: false,
      industry_dropdown_fullwidth: true,
      form: new ApiResource({
        business_id: 0,
        business_name: '',
        slug: '',
        industry_id: 0,
        company_size: 0,
        phone_number: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        token: '',
        tracking_reference: '',
        tier: '',
        hubspot_cookie: null
      }),
      form_errors: new Errors(),
      is_sending: false,
      agreement_checked: false,
      show_thank_you: false,
      disableStrength: true,
      company_sizes: Object.freeze([
        {
          value: 10,
          name: '1-10 employees'
        },
        {
          value: 50,
          name: '11-50 employees'
        },
        {
          value: 200,
          name: '51-200 employees'
        },
        {
          value: 500,
          name: '201-500 employees'
        },
        {
          value: 1000,
          name: '501-1000 employees'
        },
        {
          value: 5000,
          name: '1001-5000 employees'
        },
        {
          value: 10000,
          name: '5001-10,000 employees'
        },
        {
          value: 99999,
          name: '10,001+ employees'
        }
      ])
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Onboard'
    })
    if (this.tier !== 'g1') {
      const redirectRoute = `${window.location.protocol}//${window.location.host}/onboard/create/g1/${this.frequency}`
      window.location.href = redirectRoute
    }
  },
  created () {
    this.fetchIndustryList()
    this.businessAxios = axios.create({
      baseURL: process.env.API_URL
    })
    this.billingAxios = axios.create({
      baseURL: process.env.API_URL
    })
    this.formsApiAxios = axios.create({
      baseURL: process.env.HUBSPOT_FORMS_API_URL
    })
    const tracking = this.$cookie.get('__itluid')
    if (typeof tracking !== 'undefined' && tracking !== null) {
      this.form.tracking_reference = tracking
    } else {
      this.form.tracking_reference = this._uid
    }
    this.form.tier = this.tier
    this.onboard_date = this.getCurrentMySQLDate()
  },
  computed: {
    ...mapState({
      industryList: state => state.industries
    }),
    showThankYouMessage () {
      // change message based on whether or not the package is free
      const bold = `<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>`
      const remainder = `Our team will review your information. Once this is done, your account<br/>will be activated and a welcome email will be sent to ${this.thankYouFreeEmail} to get you started.`
      return bold + remainder
    },
    isFetchingBusinesses () {
      return this.is_fetching_business
    },
    isBusinessSelected () {
      return this.business_is_selected
    },
    isSelectedBusinessAvailable () {
      return this.business_is_selected && this.selected_business_available
    },
    isSelectedBusinessNotAvailable () {
      return this.business_is_selected && !this.selected_business_available
    },
    searchBusinessesFound () {
      return this.searchResults.length > 0 || this.businesses.length
    },
    canSubmit () {
      let ok = false
      const otherFields = this.form.email.length > 0 &&
        this.form.first_name.length > 0 &&
        this.form.industry_id > 0 &&
        this.form.last_name.length > 0 &&
        this.form.password.trim().length > 7

      if (this.business_is_selected) {
        ok = this.selected_business_available
      } else {
        ok = this.form.business_name.length > 0
      }

      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return ok && otherFields && regex.test(this.form.email.trim())
    },
    invalidEmail () {
      if (this.form.email.length === 0) {
        return false
      }
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return !regex.test(this.form.email.trim())
    },
    invalidPassword () {
      if (this.form.password.trim().length === 0) {
        return false
      }
      return this.form.password.trim().length < 8
    },
    makeFormName () {
      const formTier = this.tier.startsWith('g') ? 'growth' : 'premium'
      return `create${formTier}${this.frequency}`
    }
  },
  methods: {
    ...mapActions({
      fetchIndustryList: `${FETCH_INDUSTRIES}`
    }),
    hideIndustryDropdown () {
      this.show_industry_dropdown = false
    },
    showIndustryDropdown () {
      this.show_industry_dropdown = true
    },
    closeBusinessAutocomplete () {
      console.log('closing business autocomplete')
    },
    selectIndustry (event) {
      this.form.industry_id = event.value
    },
    selectCompanySize (event) {
      this.form.company_size = event.value
    },
    async searchBusinesses (e) {
      this.searchResults = this.businesses = []
      this.business_is_selected = false
      this.form.business_id = 0
      const searchTerm = e.target.value
      // const searchTerm = encodeURIComponent(e.target.value)
      if (typeof this.searchCancelToken !== 'undefined') {
        this.searchCancelToken.cancel('Operation cancelled due to new request from user search input')
      }
      if (searchTerm.length < 4) {
        this.is_fetching_business = false
        return
      }
      this.is_fetching_business = true
      this.searchCancelToken = axios.CancelToken.source()
      try {
        let keyword = encodeURIComponent(this.form.business_name)
        const results = await this.businessAxios.get(`/search/unclaimed-business?name=${keyword}`)
        this.is_fetching_business = false
        if (typeof results.data !== 'undefined' && results.data.length > 0) {
          results.data.forEach((record) => {
            record.id = record.id
            record.name = record.name
            record.slug = record.slug
            record.status = record.status
          })
          this.searchResults = this.businesses = results.data
        } else {
          this.searchResults = this.businesses = []
        }
      } catch (error) {
        console.log('request elastic error', error)
      }
    },
    selectBusiness (business) {
      this.business_is_selected = true
      this.searchResults = this.businesses = []
      this.form.business_name = business.name
      this.form.business_id = business.id
      this.form.slug = business.slug
      this.selected_business_available = business.status !== 'ACTIVE'
    },
    hideBusinessAutoComplete () {
      this.searchResults = this.businesses = []
    },
    showSearchDropdown () {
      console.log('show dropdown')
    },
    createOnboardRequest () {
      this.$refs.recaptcha.execute()
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaVerified (recaptchaToken) {
      this.is_sending = true
      this.form_errors.clear()
      this.$refs.recaptcha.reset()
      this.form.token = recaptchaToken
      const hutkCookie = this.$cookie.get('hubspotutk')
      this.form.hubspot_cookie = hutkCookie
      this.thankYouFreeEmail = this.form.email
      const onboard_created_field = process.env.HUBSPOT_FORMS_ONBOARD_FIELD_NAME

      let fields = [
        {
          objectTypeId: '0-1',
          name: 'email',
          value: this.form.email
        },
        {
          objectTypeId: '0-1',
          name: 'firstname',
          value: this.form.first_name
        },
        {
          objectTypeId: '0-1',
          name: 'lastname',
          value: this.form.last_name
        },
        {
          objectTypeId: '0-2',
          name: 'name',
          value: this.form.business_name
        },
        {
          objectTypeId: '0-2',
          name: onboard_created_field,
          value: this.onboard_date
        }
      ]
      if (typeof this.form.phone_number !== 'undefined' && this.form.phone_number.length > 0) {
        fields.push({
          objectTypeId: '0-1',
          name: 'phone',
          value: this.form.phone_number
        })
      }

      this.form.send('/onboard/create')
        .then((data) => {
          const hubspotPortalId = process.env.HUBSPOT_CODE
          const paidFormId = process.env.HUBSPOT_FORMS_PAID_ID
          const formUrl = `submissions/v3/integration/submit/${hubspotPortalId}/${paidFormId}`

          this.formsApiAxios.post(formUrl, {
            fields: fields,
            context: {
              hutk: hutkCookie
            }
          }).then((response) => {
            console.log('forms API Response', response)
          })
          this.is_sending = false
          if (typeof data.token !== 'undefined' && data.token.length > 0) {
            // free auto login
            localStorage.clear()
            if (typeof window.Intercom !== 'undefined') {
              window.Intercom('shutdown')
            }
            this.sending = false
            localStorage.setItem('auth_token', data.token)
            localStorage.setItem('is_ops', JSON.parse(data.is_ops))
            localStorage.setItem('first_name', data.first_name)
            localStorage.setItem('last_name', data.last_name)
            localStorage.setItem('email', data.email)
            localStorage.setItem('mobile_number', data.mobile_number)
            localStorage.setItem('roles', JSON.stringify(data.roles))
            localStorage.setItem('is_hp_admin', JSON.parse(data.is_hp_admin))
            localStorage.setItem('can_add_more_users', JSON.parse(data.can_add_more_users))
            localStorage.setItem('org_slug', data.org_slug)
            localStorage.setItem('user_id', data.user_id)
            localStorage.setItem('is_admin_menu_active', false)
            localStorage.setItem('user_hash', data.user_hash)
            this.setDefaultBusiness(data.roles)
            const email = localStorage.getItem('email')
            const firstName = localStorage.getItem('first_name')
            const lastName = localStorage.getItem('last_name')
            const fullName = `${firstName} ${lastName}`.trim()
            const createdAt = localStorage.getItem('org_join_date')
            const userHash = localStorage.getItem('user_hash')
            window.Intercom('boot', {
              app_id: process.env.INTERCOM_ID,
              name: `${fullName}`,
              email: `${email}`,
              user_hash: userHash,
              created_at: createdAt
            })
            axios.get(`/${data.org_slug}/billing-details`)
              .then((response_data) => {
                localStorage.setItem('billingDetails', JSON.stringify(response_data.data))

                // push GTM event
                this.$gtm.trackEvent({
                  event: 'conversionSuccess',
                  type: 'Login'
                })

                let url
                if (this.$route.query.redirect) {
                  url = this.$route.query.redirect
                } else if (localStorage.is_admin_menu_active === 'true' && localStorage.is_hp_admin === 'true') {
                  url = '/reviews-listing'
                } else {
                  url = '/'
                }
                this.$router.replace(url)
              })
              .catch((error) => {
                console.log('get billing details error', error)
              })
            // end free auto login
          } else {
            if (this.tier === 'free') {
              this.show_thank_you = true
            } else {
              this.$router.push(`/onboard/checkout/${data.business_id}/${this.tier}/${this.frequency}`)
            }
          }
        })
        .catch(() => {
          this.is_sending = false
        })
    },
    /**
     * Handle add new unclaimed business
     * @return {void}
     */
    handleAddBusiness () {
      axios.post(`onboard/can-add-business`, {
        business_name: this.form.business_name
      })
        .then(({data}) => {
          this.businesses = []
          this.business_is_selected = this.selected_business_available = true
        })
        .catch((error) => {
          this.showFlash(error.response.data.business_name[0], 'is-danger')
          console.log(error.response.data)
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_register.scss';

.no-height {
  height: 0;
}

.onboard-container > .columns > .column:first-child {
  padding-bottom: 37px;
}

.onboard-container > .columns > .column:last-child {
  padding-bottom: 37px;
}

.equal-height {
  display: flex;
  flex-direction: column;
  justify-content: space-between
}

.columns .want-to-know-more {
  margin-top: auto;
}

.form-box {
  width: 100%;
  max-width: 697px;
  margin: 0 auto;
}

.Create-your-account {
  margin-top: 40px;
  font-family: 'Montserrat';
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.86;
  letter-spacing: normal;
  text-align: center;
}

.Business-details, .User-details {
  margin-top: 22px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.User-details {
  margin-top: 37px;
}

.form-para {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  margin-bottom: 15px;
}

.input {
  height: 40px;
  border: solid 1px #dbdbdb;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  padding-left: 18px;
}

div.outter-ring {
  background-color: #f7fcfe;
  padding: 15px;
  border-radius: 50%;
  width: 185px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  padding-top: 19px;
  padding-bottom: 37px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
}

div.inner-ring {
  border-radius: 50%;
  padding: 15px;
  width: 114px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  margin-top: 19px;
  background-color: #edf8fd;
}

/*h1 {*/
/*  color: #555e65*/
/*}*/

.thank-you-hero {
  margin-top: 100px;
  margin-bottom: 100px;
}

.field.is-grouped > .control:not(:last-child) {
  margin-bottom: 0;
  margin-right: 15px;
}

.field:not(:last-child) {
  margin-bottom: 15px;
}

p + .field.is-grouped {
  margin-top: 15px;
}

/*.summary {*/
/*  font-family: Montserrat;*/
/*  margin-top: 40px;*/
/*  font-size: 21px;*/
/*  font-weight: bold;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.19;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #1261a0;*/
/*}*/

.summary-column {
  border-left: solid 1px rgba(112, 112, 112, 0.12);
}

.columns {
  margin-top: 0;
}

.columns:last-child {
  margin-bottom: 0;
}

/*.Plan {*/
/*  margin-top: 30px;*/
/*  font-family: Montserrat;*/
/*  font-size: 16px;*/
/*  font-weight: bold;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.19;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

/*.Plan + p {*/
/*  font-family: Open Sans;*/
/*  font-size: 16px;*/
/*  font-weight: normal;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.38;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

/*.Plan + p + p {*/
/*  margin-top: 5px;*/
/*  font-family: Open Sans;*/
/*  font-size: 14px;*/
/*  font-weight: normal;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.36;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

.agree-label {
  font-family: Open Sans;
  font-size: 16px;
  margin-top: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.agree-label > a, .agree-label > a:visited {
  text-decoration: none;
  color: #58595b;
}

.agree-label > a:hover {
  text-decoration: underline;
  color: #58595b;
}

.agree-label > .checkbox {
  width: 17px;
  height: 17px;
  -webkit-appearance: none;
  border-radius: 0;
  border: solid 1px #ebebeb;
}

input[type=checkbox]:before {
  /* Show some fake element to keep the space for empty "square" */
  content: '\f0c8';
  color: transparent;
}

input[type=checkbox]:checked:before {
  content: '\2713 ';
  /* top: 2px; */
  /* left: 20px; */
  padding-left: 2px;
  font-size: 15px;
  line-height: 0.8;
  color: #58595b;
  font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
}

p.ask-sign-in {
  margin-top: 20px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

p.ask-sign-in > a, p.ask-sign-in > a:hover, p.ask-sign-in > a:visited {
  font-weight: normal;
  text-decoration: underline;
}

p.want-to-know-more {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

p.want-to-know-more > a, p.want-to-know-more > a:hover, p.want-to-know-more > a:visited {
  color: #30aae1;
  text-decoration: underline;
}

.VuePassword__Toggle {
  color: gray !important;
}

.VuePassword__Input {
  border: none;
  height: 40px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  padding-left: 18px;
}


.mini-notes {
  color: #58595b;
  padding: 5px 14px;
  font-size: 12px;
}

.dropdown-section .control {
  /*position: absolute;*/
}

.dropdown-section .control .dropdown {
  width: 100%;
}

.dropdown-section .control .dropdown-menu {
  width: 100%;
}

.dropdown-section .selected-business {
  top: 15%;
  left: 3%;
  color: transparent;
  z-index: 1;
  opacity: 0.32;
  padding: 3px 8px;
  position: absolute;
  font-size: 14px;
  font-weight: 600;
  /*background-color: #1f91c3;*/
}

.no-business {
  color: #58595b;
  font-size: 12px;
}

.no-business .is-button-dark-blue {
  width: 65%;
}

.no-business-section {
  padding: 12px 0px;
  margin: 0px 12px;
  border-bottom: solid 1px rgba(88, 89, 91, 0.4);
}

/**
 * TODO: use placeholder solution below if feedback from Alon and Jolandi such that they want a different colour
 */

/*::placeholder { !* Chrome, Firefox, Opera, Safari 10.1+ *!*/
/*  color: red;*/
/*  opacity: 1; !* Firefox *!*/
/*}*/

/*:-ms-input-placeholder { !* Internet Explorer 10-11 *!*/
/*  color: red;*/
/*}*/

/*::-ms-input-placeholder { !* Microsoft Edge *!*/
/*  color: red;*/
/*}*/

/**
 * TODO: END
 */


.icon.green {
  color: #16be85;
  height: 40px;
  width: 40px;
}

.icon.red {
  color: #fb492c;
  height: 40px;
  width: 40px;
}

@media screen and (min-width: 768px) {
  .input, .VuePassword {
    width: 341px;
  }

  .column.is-two-thirds {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 73%;
  }

  .column.is-two-thirds + .column {
    padding-left: 50px;
    padding-right: 37px;
  }

  .VuePassword {
    height: 40px;
    /*border: solid 1px #dbdbdb;*/
  }

  .VuePassword > div > input {
    height: 40px !important;
  }

  .thank-you-header {
    width: 590px;
    max-width: 610px;
    height: 136px;
    font-family: Montserrat;
    font-size: 56px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
    margin: 20px auto 0 auto;
  }

  .thank-you-msg {
    width: 746px;
    max-width: 755px;
    height: 72px;
    font-family: Open Sans;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    margin: 0 auto;
    color: #58595b;
  }
}

@media screen and (min-width: 1400px) {
  .container {
    max-width: 1400px;
    width: 1400px;
  }
}

@media screen and (max-width: 767px) {
  .onboard-container > .columns > .column {
    margin-left: 0;
    margin-right: 0;
    padding-left: 30px;
    padding-right: 30px;
  }

  .Create-your-account {
    margin-top: 10px;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
  }

  .router-view {
    margin-top: 50px;
  }

  .Business-details {
    margin-top: 16px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .form-para {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .control {
    width: 100%;
  }

  .field.is-grouped > .control:not(:last-child), .field.is-grouped.is-grouped-multiline > .control:last-child {
    margin-bottom: 10px;
  }

  .input {
    padding-left: 15px;
    height: 35px;
  }

  .VuePassword {
    height: 35px;
    /*border: solid 1px #dbdbdb;*/
  }

  .VuePassword > div > input {
    height: 35px !important;
    padding-left: 15px;
  }

  .User-details {
    margin-top: 20px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .agree-label {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    margin-top: 13px;
    padding-left: 30px;
  }

  .agree-label > .checkbox {
    margin-left: -30px;
  }

  input[type=checkbox]:checked {
    background-color: #ffffff !important;
  }

  /*.summary {*/
  /*  border-top: solid 1px rgba(112, 112, 112, 0.12);*/
  /*  margin-top: 25px!important;*/
  /*  padding-top: 23px;*/
  /*  font-family: Montserrat;*/
  /*  font-size: 18px;*/
  /*  font-weight: bold;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.22;*/
  /*  letter-spacing: normal;*/
  /*  text-align: center;*/
  /*  color: #1261a0;*/
  /*}*/
  .summary-column {
    margin-top: 0 !important;
    padding-top: 0;
  }

  .onboard-container > .columns > .column:first-child {
    padding-bottom: 0;
  }

  /*.Plan {*/
  /*  font-family: Montserrat;*/
  /*  font-size: 14px;*/
  /*  font-weight: bold;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.29;*/
  /*  letter-spacing: normal;*/
  /*  text-align: left;*/
  /*  color: #58595b;*/
  /*  margin-bottom: 8px;*/
  /*}*/
  /*.Plan + p {*/
  /*  font-family: Open Sans;*/
  /*  font-size: 14px;*/
  /*  font-weight: normal;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.36;*/
  /*  letter-spacing: normal;*/
  /*  text-align: left;*/
  /*  color: #58595b;*/
  /*}*/
  /*.want-to-know-more {*/
  /*  font-family: OpenSans;*/
  /*  font-size: 14px!important;*/
  /*  font-weight: normal;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.36!important;*/
  /*  letter-spacing: normal;*/
  /*  text-align: center!important;*/
  /*  color: #58595b;*/
  /*  margin-top: 42px!important;*/
  /*}*/
  .onboard-container > .columns > .column:last-child {
    padding-bottom: 25px;
  }

  .thank-you-hero {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .thank-you-header {
    font-family: Montserrat;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
    margin-top: 23px;
  }

  .thank-you-msg {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: center;
    color: #58595b;
    margin-top: 17px;
  }

  .hero-body {
    padding-bottom: 20px;
  }
}


</style>

<!-- Global CSS Begins -->
<style lang="scss">
$success: #16be85;
$danger: #fb492c;
$info: #31AAE1;
$warning: #fb922c;
$bg-color: #fff;

.toast-container {
  min-width: 25%;
  max-width: 50%;

  &.top-right {
    right: 1%;
  }

  .toasted.outline {
    color: $bg-color;
    opacity: 0.8 !important;
    padding: 10px 15px;
    font-weight: 600;
    justify-content: end;
    border-radius: 5px;
    background-color: $bg-color;

    &.is-success {
      border: none;
      background-color: $success;
    }

    &.is-danger {
      border: none;
      background-color: $danger;
    }

    &.is-info {
      border: none;
      background-color: $info;
    }

    &.is-warning {
      border: none;
      background-color: $warning;
    }
  }

  .toasted .fa, .toasted .fab, .toasted .far,
  .toasted .fas, .toasted .material-icons, .toasted .mdi {
    font-size: 30px;
  }

  /*Mobile view*/
  @media screen and (max-width: 767px) {
    left: 1%;
    max-width: 100%;
  }
}
</style>
<!-- Global CSS Ends -->



// WEBPACK FOOTER //
// src/pages/onboarding/Onboard.vue